import React from 'react'
import styles from './Experience.module.scss'
import Content from '../../components/content/Content'
import { useNavigate } from 'react-router-dom'
import MoveHeader from '../../hooks/MoveHeader'

const Experience = () => {
    const navigator = useNavigate();
    const {setHeaderIndex} = MoveHeader();

    const moveToPath = (path: string, headerIndex: number) => {
        setHeaderIndex(headerIndex);
        navigator(path);
    }
    
    return (
        <div>
            <Content>
                <div className={styles.bg} >
                    <div className={styles.content_wrap}>
                        <div className={styles.left}>
                            <div className={styles.logo} />
                            <div className={styles.button_box}>
                                <div onClick={()=>{moveToPath("/", 0)}} className={styles.check_button}>서비스 확인하기</div>
                                <div onClick={()=>{moveToPath("/inquire", 4)}} className={styles.inquire_button}>도입 문의하기</div>
                            </div>
                        </div>
                        <div className={styles.right}>  
                            <iframe src={process.env.REACT_APP_DDOKDDOK_EXPERIENCE} />
                        </div>
                    </div>
                    
                </div>
            </Content>
        </div>
    )
}

export default Experience
